const initialTipoData = {
	descripcion:'',
	icono:'',
	color:''
};

const initialArrayTipoData = [];

export { initialTipoData, initialArrayTipoData };
